// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"133":"layout","528":"reports","894":"hazmat","945":"dashboard"}[chunkId] + "." + {"133":"f67cbe22","528":"5dcfaf29","894":"da957e5a","945":"dcb44292"}[chunkId] + ".chunk.css";
};